import { NgModule } from '@angular/core';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { SharedModule } from '../../../../shared/shared.module';
import { LFDropdownModule } from '../../../../shared/dropdown/dropdown.module';
import { SingleDateRangeSimpleComponent } from './single-date-range-simple.component';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        LFDropdownModule.forRoot(),
        MatSelectModule,
    ],
    declarations: [SingleDateRangeSimpleComponent],
    exports: [SingleDateRangeSimpleComponent],
})
export class SingleDateRangeSimpleModule
{
}
